"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = withStatefulFilter;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _coreDecorators = require("core-decorators");

var _withFilter = _interopRequireDefault(require("./with-filter"));

function withStatefulFilter(filterConfig, namespace) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      onChange = _ref.onChange,
      initialValues = _ref.initialValues;

  return function (WrappedComponent) {
    var _class;

    var WithStatefulFilter = (0, _coreDecorators.autobind)(_class =
    /*#__PURE__*/
    function (_PureComponent) {
      (0, _inherits2.default)(WithStatefulFilter, _PureComponent);

      function WithStatefulFilter() {
        var _this;

        (0, _classCallCheck2.default)(this, WithStatefulFilter);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithStatefulFilter).call(this));
        _this.state = {
          filters: {},
          sorting: {}
        };
        _this.WithFilter = (0, _withFilter.default)(filterConfig, namespace, {
          filterValues: function filterValues(namespace, props) {
            return props.filters;
          },
          sortingValues: function sortingValues(namespace, props) {
            return props.sorting;
          },
          setFilters: function setFilters() {
            return function (namespace, filters) {
              return new _promise.default(function (resolve) {
                return _this.setState({
                  filters: filters
                }, function () {
                  return resolve(_this.state);
                });
              });
            };
          },
          setSorting: function setSorting() {
            return function (namespace, sorting) {
              return new _promise.default(function (resolve) {
                return _this.setState({
                  sorting: sorting
                }, function () {
                  return resolve(_this.state);
                });
              });
            };
          },
          resetFilters: function resetFilters() {
            return _this.setState({
              filters: {}
            });
          },
          resetSorting: function resetSorting() {
            return _this.setState({
              sorting: {}
            });
          },
          onChange: onChange,
          initialValues: initialValues
        })(WrappedComponent);
        return _this;
      }

      (0, _createClass2.default)(WithStatefulFilter, [{
        key: "render",
        value: function render() {
          var WithFilter = this.WithFilter;
          return _react.default.createElement(WithFilter, (0, _extends2.default)({}, this.props, {
            filters: this.state.filters,
            sorting: this.state.sorting
          }));
        }
      }]);
      return WithStatefulFilter;
    }(_react.PureComponent)) || _class;

    return WithStatefulFilter;
  };
}